import { useEffect, useMemo } from 'react';

import { TermsPolicy } from 'pages/public/components/common';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from 'ui/components/common';
import { cn } from 'utils/helpers';
import { hero5 } from 'pages/private/containers/onboarding/assets/images';

import { useVerifyOtp } from '../../hooks';
import PublicWrapper from '../PublicWrapper';

const Welcome = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { mutate: verifyOtp } = useVerifyOtp();

  const otp = useMemo(() => params.get('otp') ?? '', [params]);
  const referenceId = useMemo(() => params.get('referenceId') ?? '', [params]);

  useEffect(() => {
    verifyOtp(
      {
        otp,
        referenceId,
        type: 'ACCOUNT_INVITE',
        source: 'account',
      },
      {
        onError: () => {
          window.location.href = '/';
        },
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp, referenceId]);

  return (
    <PublicWrapper
      className={cn('h-screen', 'flex flex-col items-center justify-center')}
    >
      <div
        className={cn(
          'mt-24 gap-y-7 p-4',
          'flex flex-col items-center',
          'text-center',
        )}
      >
        <img
          alt="Hero5"
          className="mx-auto inline-block h-[306px] w-[367px]"
          src={hero5}
        />
        <h3 className="text-xl font-semibold">Welcome to leapify</h3>
        <p className="text-sm">
          Build and manage any customer related work right from Leapify. Track
          and collaborate on <br /> tasks, stages, due dates and more without
          switching to another tool.
        </p>
        <Button
          type="button"
          className="lg primary font-semibold"
          label="SET PASSWORD"
          onClick={() =>
            navigate(
              `/invite/set-password?referenceId=${referenceId}&otp=${otp}`,
            )
          }
        />
      </div>
      <TermsPolicy />
    </PublicWrapper>
  );
};

export default Welcome;
